var exports = {
  "main": "xf0b3b88a--d20b1c--main",
  "main--small": "xf0b3b88a--d20b1c--main--small",
  "main--large": "xf0b3b88a--d20b1c--main--large",
  "main--xlarge": "xf0b3b88a--d20b1c--main--xlarge",
  "outline": "xf0b3b88a--d20b1c--outline",
  "outline--large": "xf0b3b88a--d20b1c--outline--large",
  "outline--xlarge": "xf0b3b88a--d20b1c--outline--xlarge",
};

module.exports = exports;
